import type { DiagnosticsHostCommonProps } from './DiagnosticsHostCommon';
import type * as lazyIndex from './lazyIndex';
import { LazyAction, type LazyComponent, LazyModule, createLazyComponent } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "DiagnosticsCommon"*/ './lazyIndex'),
    { name: 'DiagnosticsCommon' }
);

export const DiagnosticsHostCommon: LazyComponent<DiagnosticsHostCommonProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.DiagnosticsHostCommon);
export const lazyOpenDiagnosticsPane: LazyAction<
    typeof lazyIndex.openDiagnosticsPane,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.openDiagnosticsPane);
